<template>
  <div>
    <van-nav-bar title="兑换记录" left-text="" left-arrow @click-left="onClickLeft()" />
    <div style="margin-left:15px;margin-top:10px;">
      <van-button plain hairline round type="danger" size="mini" @click="onEdit">收货地址</van-button>
    </div>
    <div class="table_detail" style="margin-top:10px;">
      <table>
        <thead>
          <tr>
            <th>序号</th>
            <th>奖品名称</th>
            <th>尺码</th>
            <th>兑换单量</th>
            <th>是否兑换</th>
            <th>兑换码</th>
            <th>兑换时间</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,idx) in convertList" v-bind:key="idx">
            <td>{{ idx+1 }}</td>
            <td>{{ item.PrizeName }}{{ item.PrizeDesc }}</td>
            <td>{{ item.PrizeSize==null?'-':item.PrizeSize }}</td>
            <td>{{ item.CurrentNum }}单</td>
            <td>{{ item.IsGrant==1?'是':'否' }}</td>
            <td>{{ item.WinningCode }}</td>
            <td>{{ item._CreateTime }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <van-pagination
      mode="simple"
      v-model="currentPage"            
      :page-count="pageCount"
      :show-page-size="3"
      force-ellipses
      style="margin-top:10px;" @change="handleCurrentChange" />
  </div>
</template>
 
<script>
import { Button, NavBar, Pagination } from "vant";
export default {
  data() {
    return {
      currentPage: 1,
      convertList: [],
      loading: false,// 是否处在加载状态
      finished: false,// 是否已加载完成
      total: 0,// 数据总条数
      pageCount: 0,// 总页数
      pageSize: 0, // 每页条数
    }
  },
  props: {},
  computed:{
    isLogined(){return this.$store.state.isLogin}
  },
  created() {},
  mounted() {
  },
  components: {
    [NavBar.name]: NavBar,
    [Pagination.name]: Pagination,
    [Button.name]: Button,
  },
  methods: {
    ShowLogin(){
      this.$store.commit("showLogin");
    },
    GetData(){
      var that = this;
      if(that.isLogined){        
        that.$http.get("Prizes/GetSDWorkerConvertList", {
          params: {
            pageindex: that.currentPage
          }
        }).then(res=>{
          that.convertList=res.data.ListData;
          that.total = res.data.TotalCount;		// 给数据条数赋值
          that.loading = true;			// 加载状态结束 
          that.pageCount = res.data.PageCount;
          that.pageSize = res.data.PageSize;
          // 如果list长度大于等于总数据条数,数据全部加载完成
          if (that.convertList.length >= res.data.TotalCount) {
            that.finished = true;		// 结束加载状态
          }
        });
      }
    },
    handleCurrentChange (page) {
      this.currentPage = page;
      this.GetData();
    },
    onEdit(item, index) {
      this.$router.push({
        name: "ConvertAddrsDetail",
        params: {},
      });
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  created() {
    this.GetData();
  },
}
</script>
<style scoped>
  .table_detail{
    overflow:auto;
    width: 100%;
    /* 固定滚动高度 */
    max-height: calc(100vh - 220px);
    border-top: 1px solid #EBEBEB;
    border-bottom: 1px solid #EBEBEB;
    border-right: 0;
    
  }
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }
  td, th {
    border-right: 1px solid #EBEBEB;
    border-bottom :1px solid #EBEBEB;
    width:100px;
    height: 35px;
    color: #333;
    box-sizing: border-box;
    background-color: #ffffff;
    font-size: 12px;
    text-align: center;
    padding: 5px 5px 5px 0;
  }
  th {
    background: #FAFAFA;
    color: #999;
    font-weight: normal;
  }
  /* 固定首列*/
  td:first-child,
  th:first-child {
    width:100px;
    position:sticky;
    left:0;
    z-index:1;
    padding-left: 5px;
  }
  /* 固定表头*/
  thead tr th {
    position:sticky;
    top:0;
  }
  th:first-child{
    z-index:2;
  }
  /* 固定表头*/
  tfoot tr th {
    position:sticky;
    bottom:0;
    color: #333;
    font-weight: bold;
    border-bottom: 0;
  }
  th:first-child{
    z-index:2;
  }
</style>